import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import HasilDarahSvc from "@/services/HasilPemeriksaanDarah";

@Module({ store, dynamic: true, namespaced: true, name: "hasil-pemeriksaan-darah" })
class HasilPemeriksaanDarahModule extends VuexModule {
  items: any[] = [];

  loading = false;

  katalog: Record<string, any> = {};

  registerId: string | null = null;

  @Mutation
  SET_ITEMS(items: any[]) {
    this.items = items || [];
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  SET_KATALOG(val: Record<string, any>) {
    this.katalog = val || {};
  }

  @Mutation
  SET_REGISTER_ID(val: string | number | null) {
    this.registerId = val === null || val === undefined ? null : String(val);
  }

  @Mutation
  RESET() {
    this.items = [];
    this.loading = false;
    this.registerId = null;
  }

  @Action
  async getByRegister(register: string | number) {
    if (this.registerId !== String(register)) {
      this.SET_ITEMS([]);
    }

    this.SET_REGISTER_ID(register);
    this.SET_LOADING(true);

    try {
      const resp = await HasilDarahSvc.getByRegister(register);

      if (this.registerId !== String(register)) return;

      const data = resp && resp.data ? resp.data.data : null;
      this.SET_ITEMS(Array.isArray(data) ? data : []);
    } catch {
      if (this.registerId === String(register)) {
        this.SET_ITEMS([]);
      }
    } finally {
      this.SET_LOADING(false);
    }
  }

  @Action
  async loadKatalog() {
    if (Object.keys(this.katalog).length) return;

    try {
      const resp = await HasilDarahSvc.katalog();
      const data = resp && resp.data ? resp.data.data : null;
      this.SET_KATALOG(data || {});
    } catch {
      this.SET_KATALOG({});
    }
  }

  @Action
  reset() {
    this.RESET();
  }
}

export const storeHasilPemeriksaanDarah = getModule(HasilPemeriksaanDarahModule);
export default storeHasilPemeriksaanDarah;
